import KeyboardArrowDownRoundedIcon from '@mui/icons-material/KeyboardArrowDownRounded';
import { Typography } from '@mui/material';
import styled from 'styled-components';
import { capitalizeWords } from '../../../utils/common';
import { fontSize, space } from '../../../style/utils';

export const CollapseArrowIcon = styled(KeyboardArrowDownRoundedIcon)<{
  $expanded: boolean;
  $dimWhenCollapsed?: boolean;
}>`
  transition: transform 0.2s ease, opacity 0.2s ease;
  transform: rotate(${({ $expanded }) => ($expanded ? '0deg' : '-90deg')});
  font-size: ${fontSize('xl')};
  color: ${({ theme }) => theme.palette.content.tertiary};
  opacity: ${({ $expanded, $dimWhenCollapsed = true }) =>
    $expanded || !$dimWhenCollapsed ? 1 : 0};
`;

export const formatToolName = (name: string = '') =>
  name.includes('graphql')
    ? 'Search Elementary Data'
    : capitalizeWords(name.replaceAll('_', ' '));

export const ToolText = styled(Typography)<{ $running?: boolean }>`
  color: ${({ theme }) => theme.palette.accent.ai};
  font-size: ${fontSize('base')};
  margin: ${space('xs', 0)};
  position: relative;

  ${({ $running, theme }) =>
    $running &&
    `
    animation: shimmer 1.5s ease-in-out infinite;
    
    &::after {
      content: '';
      position: absolute;
      top: 0;
      left: -100%;
      width: 100%;
      height: 100%;
      background: linear-gradient(90deg, 
        transparent 0%, 
        ${theme.palette.surface.translucent.frostedLight} 50%, 
        transparent 100%);
      animation: shimmerSlide 1.5s ease-in-out infinite;
    }
    
    @keyframes shimmer {
      0%, 100% {
        opacity: 0.7;
      }
      50% {
        opacity: 1;
      }
    }
    
    @keyframes shimmerSlide {
      0% {
        left: -100%;
      }
      100% {
        left: 100%;
      }
    }
  `}
`;
